import Cookies from "js-cookie";
import axios from "../../../util/axios";

export async function addDoctor(name) {
  try {
    const headers = {
      Authorization: `Bearer ${Cookies.get("token")}`,
    };
    const { data } = await axios.post(
      `admin/v1/clinic/${Cookies.get("clinic_id")}/doctors`,
      { name },
      {
        headers,
      },
    );
    return data.message;
  } catch (error) {
    console.error("Error add doctor:", error);
    throw error;
  }
}
